import { crudService, tanqueService } from '../_services';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const tanqueAction = {
    getTanque,
    getTanqueByPeriodo,
    getTanqueByFazenda,
    getTanqueById,
    importTanques,
    onChangeProps,
    editTanqueInfo,
    createTanque,
    deleteTanqueById,
    clear
};
function getTanque(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'tanques';
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeTanquesList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function getTanqueByPeriodo(periodo, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'tanques?periodo=' + periodo;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeTanquesList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function getTanqueByFazenda(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'tanques/fazenda/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeTanquesList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function createTanque(payload) {
    return dispatch => {
        let apiEndpoint = 'tanques/';
        crudService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);

                    dispatch(createUserInfo());
                    alerts.success(ret.message, '/tanques');

                } else {
                    alerts.warning(JSON.parse(response.request.responseText).Message);
                }
            })
    }
}
function getTanqueById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'tanques/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(editTanquesDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function importTanques(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'Tanques/import';
        tanqueService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (ret.retorno === true) {
                        dispatch(createUserInfo());
                        if (showWaiting) {
                            alerts.clean();
                        }
                        alerts.success(ret.mensagem, '/tanques'); //ret.Path
                    } else {
                        dispatch(createUserInfo());
                        alerts.error(ret.mensagem, '/tanques'); //ret.Path
                    }

                } else {
                    alerts.warning(response.request.responseText);
                }

            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}
function editTanqueInfo(id, payload) {
    return dispatch => {
        let apiEndpoint = 'tanques/' + id;
        crudService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    alerts.success(ret.message, '/tanques');

                } else {
                    alerts.warning(response.request.responseText);
                }
            })
    }
}
function deleteTanqueById(id, showWaiting, id_fazenda) {
    return dispatch => {
        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (showWaiting) {
                    alerts.waiting();
                }
                if (willDelete.value) {
                    let apiEndpoint = 'tanques/' + id;
                    tanqueService.deleteTanqueDetails(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteTanqueDetails());
                                dispatch(tanqueAction.getTanqueById(id_fazenda));
                                if (showWaiting) {
                                    alerts.clean();
                                }
                                alerts.success(ret.message, '/tanques');
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })
                }
            });
    };
}

export function changeTanquesList(tanque) {
    return {
        type: "FETECHED_ALL_TANQUE",
        tanque: tanque
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editTanquesDetails(tanque) {
    return {
        type: "TANQUE_DETAIL",
        id: tanque.id,
        data_cadastro: tanque.data_cadastro,
        usuario_cadastro: tanque.usuario_cadastro,
        periodo: tanque.periodo,
        volume: tanque.volume,
        vacas_lactacao: tanque.vacas_lactacao,
        media_litros_dia: tanque.media_litros_dia,
        ccs: tanque.ccs,
        ufc: tanque.ufc,
        gordura: tanque.gordura,
        proteina: tanque.proteina,
        nul: tanque.nul,
        preco_litro: tanque.preco_litro,
        faturamento: tanque.faturamento,
        data_exclusao: tanque.data_exclusao,
        usuario_exclusao: tanque.usuario_exclusao,
        id_fazenda: tanque.usuario_exclusao
    }
}
export function updatedUserInfo() {
    return {
        type: "TANQUE_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "TANQUE_CREATED_SUCCESSFULLY"
    }
}
export function deleteTanqueDetails() {
    return {
        type: "DELETED_TANQUE_DETAILS"
    }
}
export function clear() {
    return {
        type: "TANQUE_CLEAR"
    };
}